<template>
  <div class="top-wrapper d-inline-flex align-items-center">
    <!-- Qarz muddati ogohlantirishi (badge) -->
    <router-link
      v-if="debtAlertCount > 0"
      to="/nasiyalar"
      class="debt-bell"
      :title="`${debtAlertCount} ta qarz muddati yaqin/otgan`"
    >
      <b-icon icon="bell-fill" class="bell-icon"></b-icon>
      <span class="bell-badge">{{ debtAlertCount }}</span>
    </router-link>

    <drop-down tag="li" class="nav-item">
      <a slot="title" class="nav-link user-profile-dropdown" data-toggle="dropdown" href="javascript:void(0)">
        <div class="user-avatar-wrapper">
          <b-icon icon="person-circle" class="user-icon"></b-icon>
        </div>
        <span class="username-text">{{ username }}</span>
        <b-icon style="color: rgb(107, 107, 107);" icon="chevron-down" font-scale="0.8" class="ml-1"></b-icon>
      </a>

      <ul class="dropdown-menu dropdown-menu-right custom-dropdown-menu">
        <li>
          <router-link :to="{ path: '/login' }" class="dropdown-item logout-link">
            <b-icon icon="box-arrow-right" class="mr-2"></b-icon>
            {{ $t("Chiqish") }}
          </router-link>
        </li>
      </ul>
    </drop-down>
  </div>
</template>

<style scoped>
.user-profile-dropdown {
  display: flex;
  align-items: center;
  padding: 5px 12px;
  border-radius: 13px;
  border: 1px solid rgb(107, 107, 107);
  transition: all 0.3s ease;
  background: rgba(0, 0, 0, 0.03);
  /* Engil fon */
  text-decoration: none !important;
  height: 35px;
}

.user-profile-dropdown:hover {
  background: rgba(0, 0, 0, 0.08);
}

.user-avatar-wrapper {
  margin-right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #5e72e4;
  /* Ikonka rangi */
}

.user-icon {
  font-size: 1.4rem;
}

.username-text {
  font-weight: 600;
  color: #32325d;
  font-size: 0.9rem;
}

.top-wrapper { gap: 10px; }
.debt-bell {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background: #fff7ed;
  border: 1px solid #fdba74;
  color: #f97316;
  text-decoration: none !important;
  transition: 0.2s;
  animation: bellPulse 2s infinite;
}
.debt-bell:hover { background: #fed7aa; color: #c2410c; }
.bell-icon { font-size: 1rem; }
.bell-badge {
  position: absolute;
  top: -4px;
  right: -4px;
  background: #e11d48;
  color: white;
  font-size: 10px;
  font-weight: 800;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 9999px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid white;
}
@keyframes bellPulse {
  0%, 100% { box-shadow: 0 0 0 0 rgba(249, 115, 22, 0.5); }
  50%      { box-shadow: 0 0 0 6px rgba(249, 115, 22, 0); }
}

/* Dropdown Menu dizayni */
.custom-dropdown-menu {
  border: none;
  box-shadow: 0 40px 80px rgba(50, 50, 93, 0.1), 0 15px 35px rgba(50, 50, 93, 0.15), 0 5px 15px rgba(0, 0, 0, 0.1);
  border-radius: 0.5rem;
  padding: 10px 0;
  min-width: 180px;
}

.dropdown-item {
  padding: 5px 5px;
  display: flex;
  align-items: center;
  color: #525f7f;
  transition: background 0.2s;
}

.logout-link:hover {
  background-color: #fef1f1;
  /* Chiqish uchun engil qizil fon */
  color: #f5365c;
}
</style>

<script>
import $ from "jquery";
import axios from "axios";
export default {
  data() {
    return {
      exportfolder: "",
      debtAlertCount: 0,
      _debtAlertTimer: null,
    };
  },
  computed: {
    username() {
      return localStorage.getItem('username');
    }
  },
  mounted() {
    this.fetchDebtAlertCount();
    // 2 daqiqa sayin yangilab turish
    this._debtAlertTimer = setInterval(this.fetchDebtAlertCount, 120000);
  },
  beforeDestroy() {
    if (this._debtAlertTimer) clearInterval(this._debtAlertTimer);
  },
  methods: {
    computeLocaleText(locale) {
      return this.$t(locale);
    },
    async fetchDebtAlertCount() {
      try {
        const res = await axios.get('api/v1/debt-reminder/alert-count');
        this.debtAlertCount = Number(res.data?.data?.count || 0);
      } catch (e) {
        this.debtAlertCount = 0;
      }
    },
  }
};
</script>

